import './agents-preferences-tab/agents-preferences-tab.component'
import './agents-preferences-tab/agents-preferences-tab.scss'

import './custom-fields-select/custom-fields-select.component'
import './custom-fields-select/custom-fields-select.scss'

import './dispatching-configuration-view/dispatching-configuration-view.component';
import './dispatching-configuration-view/dispatching-configuration-view.scss';

import './package-custom-fields-view/package-custom-fields-view.component';
import './package-custom-fields-view/package-custom-fields-view.scss';

import './fields-configurations-view/fields-configurations-view.component';
import './fields-configurations-view/fields-configurations-view.scss';

import './general-task-form/general-task-form.component';
import './general-task-form/general-task-form.scss';

import './general-tasks-configuration-view/general-tasks-configuration-view.component';
import './general-tasks-configuration-view/general-tasks-configuration-view.scss';

import './package-configuration-select/package-configuration-select.component';
import './package-configuration-select/package-configuration-select.scss';

import './package-configuration-select-list/package-configuration-select-list.component';
import './package-configuration-select-list/package-configuration-select-list.scss';

import './package-configuration-field-table-row/package-configuration-field-table-row.component';
import './package-configuration-field-table-row/package-configuration-field-table-row.scss';

import './package-custom-fields-table/package-custom-fields-table.component';
import './package-custom-fields-table/package-custom-fields-table.scss';

import './package-custom-fields-table-row/package-custom-fields-table-row.component';
import './package-custom-fields-table-row/package-custom-fields-table-row.scss';

import './package-configuration-input/package-configuration-input.component';
import './package-configuration-input/package-configuration-input.scss';

import './package-configurations-table/package-configurations-table.component';
import './package-configurations-table/package-configurations-table.scss';

import './package-configurations-table-row/package-configurations-table-row.component';
import './package-configurations-table-row/package-configurations-table-row.scss';

import './package-configurations-view/package-configurations-view.component';
import './package-configurations-view/package-configurations-view.scss';

import './preferences-progress-bar/preferences-slider.component';
import './preferences-progress-bar/preferences-slider.scss';

import './preferences-meta-data-view/preferences-meta-data-view.component';
import './preferences-meta-data-view/preferences-meta-data-view.scss';

import './preferences-tab/preferences-tab.component';
import './preferences-tab/preferences-tab.scss';

import './preferences-value-edit/preferences-value-edit.component';
import './preferences-value-edit/preferences-value-edit.scss';

import './preferences-value-read/preferences-value-read.component';
import './preferences-value-read/preferences-value-read.scss';

import './programs-preferences-tab/programs-preferences-tab.component';
import './programs-preferences-tab/programs-preferences-tab.scss';

import './site-module-list-item/site-module-list-item.component';
import './site-module-list-item/site-module-list-item.scss';

import './site-plan-view/site-plan-view.component';
import './site-plan-view/site-plan-view.scss';

import './vehicle-status-change-reason-select/vehicle-status-change-reason-select.component';
import './vehicle-status-change-reason-select/vehicle-status-change-reason-select.scss';

import './vehicle-status-change-reason-select-list/vehicle-status-change-reason-select-list.component';
import './vehicle-status-change-reason-select-list/vehicle-status-change-reason-select-list.scss';

import './site-preferences/site-preferences.component';
import './site-preferences/site-preferences.scss';

import './travel-time-polygons-view/travel-time-polygons-view.component';
import './travel-time-polygons-view/travel-time-polygons-view.scss';

import './travel-time-rule-panel/travel-time-rule-panel.component';
import './travel-time-rule-panel/travel-time-rule-panel.scss';

import './travel-time-rule-table/travel-time-rule-table.component';
import './travel-time-rule-table/travel-time-rule-table.scss';

import './travel-time-view/travel-time-view.component';
import './travel-time-view/travel-time-view.scss';

import './vehicles-preferences-tab/vehicles-preferences-tab.component';
import './vehicles-preferences-tab/vehicles-preferences-tab.scss';

import './views-configuration-view/views-configuration-view.component';
import './views-configuration-view/views-configuration-view.scss';

import './shipper-portal-configuration/shipper-portal-configuration.component';
import './shipper-portal-configuration/shipper-portal-configuration.scss';

import './dashboard-configuration/dashboard-configuration.component';
import './dashboard-configuration/dashboard-configuration.scss';

import './roles-groups/roles-groups.component'
import './roles-groups/roles-groups.scss'

import './roles-groups-table/roles-groups-table.component'
import './roles-groups-table/roles-groups-table.scss'

import './users-multi-select/users-multi-select.component'
import './users-multi-select/users-multi-select.scss'

import './users-multi-select-list/users-multi-select-list.component'
import './users-multi-select-list/users-multi-select-list.scss'

import './roles-group-selection/roles-group-selection.component'
import './roles-group-selection/roles-group-selection.scss'

import './email-report-configuration-tab/email-report-configuration-tab.component'
import './email-report-configuration-tab/email-report-configuration-tab.scss'
